var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 69,
    viewBox: "0 0 54 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0024 68.9911C19.2514 66.6895 12.8133 61.9949 7.68796 54.9074C2.56265 47.8199 0 39.8337 0 30.9486V10.0873L27.0024 0L54.0048 10.0873V30.9486C54.0048 39.8311 51.4421 47.8161 46.3168 54.9036C41.1915 61.991 34.7534 66.6843 27.0024 68.9911ZM27.0024 64.8983C33.6887 62.7767 39.2177 58.5334 43.5896 52.1686C47.9614 45.8038 50.1473 38.7317 50.1473 30.9524V12.722L27.0024 4.11979L3.85748 12.722V30.9486C3.85748 38.7278 6.04339 45.7999 10.4152 52.1647C14.787 58.5296 20.3161 62.7767 27.0024 64.8983Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0112 37.5479L17.6098 30.3507L15.43 32.7843L24.0112 42.4323L42.4324 21.721L40.2679 19.2874L24.0112 37.5479Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon3);
export default __webpack_public_path__ + "static/media/service_icon-3.fefa056fea5bfecf8049dbe4e34405bb.svg";
export { ForwardRef as ReactComponent };